<template>
    <div class="ambassadors" @mouseover="pause()" @mouseleave="start()">
      <div class="fx-height">
        <div class="list-item">
          <router-link :to="url" :style="titleStyle" class="link item title" tag="div">
            <div class="text">
              <span class="name">{{ 'OUR ' + name }} </span>
            </div>
          </router-link>
        </div>

        <transition name="fade" mode="out-in">
          <AmbassadorsItem :style="itemStyle" :item="random[0]" :key="random[0].photo" :index="0" />
        </transition>

        <transition name="fade" mode="out-in">
          <AmbassadorsItem :style="itemStyle" :item="random[1]" :key="random[1].photo" :index="1" />
        </transition>

        <transition name="fade" mode="out-in">
          <AmbassadorsItem :style="itemStyle" :item="random[2]" :key="random[2].photo" :index="2" />
        </transition>
      </div>
    </div>
</template>

<script>
import completeLoad from '../mixins/completeLoad'
import AmbassadorsItem from './AmbassadorsItem.vue'
import $ from 'jquery'

export default {
  props: [ 
    'url',
    'name',
    'items'
  ],

  components: {
    AmbassadorsItem
  },

  mixins: [completeLoad],

  data () {
    return {
      random: [],
      live: true,
      itemStyle: {
        height: '100%'
      },
      titleStyle: {
        height: '100%'
      }
    }
  },

  created () {
    for(let i in this.items) {
      this.imageLoad(this.items[i].photo, () => {
        this.setHeight()
      })
    }

    for (var i = 0; i < 3; i++) {
      this.random.push(this.items[i])
    }

    setInterval(() => { 
      this.setRandomItem()
    }, 3000);
  },

  mounted () {
    $(window).resize((e) => {
      this.setHeight()
    });
  },

  methods: {
    setHeight () {
      if ($(window).width() > 1018) {
        this.itemStyle.height = $('.ambassadors .list-item img').outerHeight() + 7 + 'px'
        this.titleStyle.height = $('.ambassadors .list-item img').outerHeight() + 'px'
      } else if($(window).width() > 767) {
        this.itemStyle.height = 'auto'
        this.titleStyle.height = $('.ambassadors .list-item img').outerHeight() + 7  + 'px'
      } else {
        this.titleStyle.height = $('.ambassadors .list-item img').outerHeight() + 'px'
      }
    },

    setRandomItem () {
      if (!this.live) { return }

      var free = this.items.filter((item) => {
        for(let k in this.random) {
          if (this.random[k] === item) {
            return false
          }
        }

        return true
      })

      if (!free) { return }

      var key = this.getRandomInt(0, this.random.length);
      var keyFree = this.getRandomInt(0, free.length);
      this.$set(this.random, key, free[keyFree])
    },

    start () {
      this.live = true
    },

    pause () {
      this.live = false
    },

    // использование Math.round() даст неравномерное распределение!
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    }
  }
}
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.members .ambassadors, .members .partners {
  padding: 4%;
  .fx-height {
    display: flex;
    flex-wrap: wrap;
    @media screen and (max-width: 1019px) {
      flex-wrap: nowrap;
    }

    @media screen and (max-width: 768px) {
      flex-wrap: wrap;
    }
  }
}
</style>